import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-system-selection',
  templateUrl: './system-selection.component.html',
  styleUrls: ['./system-selection.component.scss']
})
export class SystemSelectionComponent implements OnInit {

  constructor(private route:Router) { }

  ngOnInit() {
    if( window.localStorage )
    {
      if( !localStorage.getItem('firstLoad') )
      {
        localStorage['firstLoad'] = true;
        window.location.reload();
      }
      else
        localStorage.removeItem('firstLoad');
    }
  }

  travels(){
    this.route.navigate(['/travels-dashboard']);
    localStorage.setItem('system','TRAVEL')
  }

  resort(){
    this.route.navigate(['/travels-dashboard']);
    localStorage.setItem('system','RESORT')
  }

  inter() {
    this.route.navigate(['/travels-dashboard']);
    localStorage.setItem('system','INTERNATIONAL')
  }
}
